import React, { useEffect, useState, forwardRef } from 'react'
import {
  Dialog, DialogContent, Slide, Grid, Typography
} from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { InterstitialZutoLogo, TrustpilotReversed } from '@zuto/icons'
import { fireReactGAEvent } from '../../Questions/utils'
import AnimatedArrowsLarge from '../../Animations/AnimatedArrowsLarge'
import CheckedList from '../../CheckedList'

const dialogStyles = {
  px: 0,
  textAlign: 'center',
  backgroundColor: '#fff',
  opacity: 1,
  boxShadow: 0,
  zIndex: 99999999999, // Important so that the CookiePro banner doesn't overlay
  '.interstitial-header svg': {
    position: 'relative',
    transform: 'scale(0.90)'
  },
  '.MuiPaper-root': {
    margin: '0',
    width: '100%',
    padding: '30px 0',
    boxShadow: 0
  },
  '.MuiDialogContent-root': {
    maxWidth: '340px',
    margin: 'auto'
  }
}

const intEvent = (experiment: string, open: boolean) => {
  fireReactGAEvent({
    category: 'Application Form',
    action: open ? 'Interstitial Started' : 'Interstitial Ended',
    label: experiment
  })
}

const Transition = forwardRef<unknown, TransitionProps & { children: React.ReactElement }>(
  (props, ref) => <Slide unmountOnExit direction="right" ref={ref} {...props} />
)

type InterstitialProps = {
  experimentName: string
}

const FirstTimeApplicantPreInterstitialV1 = ({ experimentName }: InterstitialProps): JSX.Element => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(true)
    intEvent(experimentName, true)
  }, [])

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setOpen(false)
        intEvent(experimentName, false)
      }, 6000)
    }
  }, [open])

  const list = [
    'Complete our quick application form',
    'You\'ll get a decision in 60 seconds',
    'If approved, we\'ll call you'
  ]

  return (
    <Dialog
      open={open}
      data-testid="fta-pre-int-v1"
      TransitionComponent={Transition}
      keepMounted={false}
      aria-describedby="Pre Application Information"
      sx={dialogStyles}
      slotProps={{ backdrop: { style: { backgroundColor: 'rgba(255,255,255,1)' } } }}
      fullScreen
      fullWidth
    >
      <DialogContent sx={{ py: 12 }}>
        <TrustpilotReversed />
        <Grid container direction="column" alignItems="center" justifyContent="center" mt={5}>
          <Grid item xs={12} container direction="row" alignItems="center" justifyContent="center" spacing={3}>
            <Grid item>
            <AnimatedArrowsLarge
              testId="animated-arrows-left" 
              animationDelays={['-0.2s', '-0.4s', '-0.6s']}
            />
            </Grid>
            <Grid item sx={{ transform: 'scale(1.2)' }}>
              <InterstitialZutoLogo data-testid="zuto-logo" />
            </Grid>
            <Grid item>
              <AnimatedArrowsLarge
                testId="animated-arrows-right" 
                animationDelays={['-0.6s', '-0.8s', '-1s']}
              />
            </Grid>
          </Grid>
        </Grid>
        <Typography variant="rowHeading" color="#000" mt={8} mb={4} fontSize={16}>Spread the cost of your next car with Zuto!</Typography>
        <CheckedList list={list} darkerText />
      </DialogContent>
    </Dialog>
  )
}

export default FirstTimeApplicantPreInterstitialV1
